import React from 'react';

import { IGetRatingListResponseData } from '../../../services/getRealtorRatingList';
import { ERealtorRatingTableColumns } from '../../../constants';
import { ESortOrder } from '../../../types/sortOrder';
import { UserCardForAuthorObject } from '../../UserCard';
import { numberWithDelimiter, sortRealtorRatingItems } from '../../../utils';
import { Label } from './components/Label';
import * as s from './RealtorRatingTableTbody.css';

interface IRealtorRatingTableTbody {
  items: IGetRatingListResponseData[];
  sortOrdering: ERealtorRatingTableColumns;
  sortOrderingType: ESortOrder;
}

/**
 * Тело таблицы рейтинга риелторов
 */
export const RealtorRatingTableTbody = ({ items, sortOrdering, sortOrderingType }: IRealtorRatingTableTbody) => {
  return (
    <tbody>
      {sortRealtorRatingItems({ items, sortOrdering, sortOrderingType }).map(
        ({
          id,
          attributes: {
            position,
            rating,
            advicesCount,
            bestAdvicesCount,
            blogsCount,
            popularBlogsCount,
            reviewsCount,
            popularReviewsCount,
            specialist,
          },
        }) => (
          <tr key={id}>
            <td className={s['td-position']}>{position}</td>
            <td className={s['td-user-card']}>
              <UserCardForAuthorObject {...specialist} companyName={undefined} />
            </td>
            <td className={s['td-rating-label']}>
              <Label>{numberWithDelimiter(rating)}</Label>
            </td>
            <td className={s['td']}>{numberWithDelimiter(advicesCount)}</td>
            <td className={s['td']}>{numberWithDelimiter(bestAdvicesCount)}</td>
            <td className={s['td']}>{numberWithDelimiter(blogsCount)}</td>
            <td className={s['td']}>{numberWithDelimiter(popularBlogsCount)}</td>
            <td className={s['td']}>{numberWithDelimiter(reviewsCount)}</td>
            <td className={s['td']}>{numberWithDelimiter(popularReviewsCount)}</td>
          </tr>
        ),
      )}
    </tbody>
  );
};
